export interface GroupAttributes {
  name: string;
  data: any;
  element: HTMLElement;
}